export interface TabooItem {
    text: string;
    forbidden: string[];
    category: string;
    custom?: boolean;
}

export const CUSTOM_CATEGORY = 'Свои';

export const BASE_WORDS: TabooItem[] = [
    // Профессии
    {text: 'Врач', forbidden: ['больница', 'лечить', 'пациент', 'больной'], category: 'Профессии'},
    {text: 'Учитель', forbidden: ['школа', 'урок', 'ученик', 'класс'], category: 'Профессии'},
    {text: 'Повар', forbidden: ['еда', 'готовить', 'кухня', 'ресторан'], category: 'Профессии'},
    {text: 'Полицейский', forbidden: ['преступник', 'форма', 'закон', 'машина'], category: 'Профессии'},
    {text: 'Пожарный', forbidden: ['огонь', 'пожар', 'каска', 'машина'], category: 'Профессии'},
    {text: 'Программист', forbidden: ['код', 'компьютер', 'программа', 'баг'], category: 'Профессии'},
    {text: 'Актёр', forbidden: ['фильм', 'роль', 'кино', 'сцена'], category: 'Профессии'},
    {text: 'Фотограф', forbidden: ['камера', 'фото', 'снимок', 'кадр'], category: 'Профессии'},
    {text: 'Парикмахер', forbidden: ['волосы', 'стрижка', 'ножницы', 'салон'], category: 'Профессии'},
    {text: 'Космонавт', forbidden: ['космос', 'ракета', 'скафандр', 'планета'], category: 'Профессии'},

    // Технологии
    {text: 'Смартфон', forbidden: ['телефон', 'звонить', 'экран', 'приложение'], category: 'Технологии'},
    {text: 'Интернет', forbidden: ['сеть', 'сайт', 'wifi', 'онлайн'], category: 'Технологии'},
    {text: 'Наушники', forbidden: ['музыка', 'уши', 'слушать', 'звук'], category: 'Технологии'},
    {text: 'Робот', forbidden: ['машина', 'искусственный', 'механизм', 'железный'], category: 'Технологии'},
    {text: 'Батарейка', forbidden: ['заряд', 'энергия', 'пульт', 'электричество'], category: 'Технологии'},
    {text: 'Клавиатура', forbidden: ['кнопки', 'печатать', 'компьютер', 'буквы'], category: 'Технологии'},
    {text: 'Принтер', forbidden: ['бумага', 'печать', 'документ', 'чернила'], category: 'Технологии'},
    {text: 'Камера видеонаблюдения', forbidden: ['слежка', 'запись', 'охрана', 'объектив'], category: 'Технологии'},

    // Еда и напитки
    {text: 'Пицца', forbidden: ['сыр', 'тесто', 'Италия', 'кусок'], category: 'Еда и напитки'},
    {text: 'Кофе', forbidden: ['утро', 'кружка', 'бодрость', 'кофеин'], category: 'Еда и напитки'},
    {text: 'Мороженое', forbidden: ['холодное', 'сладкое', 'лето', 'рожок'], category: 'Еда и напитки'},
    {text: 'Суп', forbidden: ['тарелка', 'ложка', 'жидкий', 'горячий'], category: 'Еда и напитки'},
    {text: 'Шашлык', forbidden: ['мясо', 'мангал', 'костёр', 'шампур'], category: 'Еда и напитки'},
    {text: 'Торт', forbidden: ['день рождения', 'сладкий', 'крем', 'свечи'], category: 'Еда и напитки'},
    {text: 'Сушки', forbidden: ['круглый', 'дырка', 'чай', 'сладкий'], category: 'Еда и напитки'},
    {text: 'Арбуз', forbidden: ['зелёный', 'сладкий', 'косточки', 'лето'], category: 'Еда и напитки'},

    // Спорт
    {text: 'Футбол', forbidden: ['мяч', 'ворота', 'команда', 'поле'], category: 'Спорт'},
    {text: 'Плавание', forbidden: ['бассейн', 'вода', 'плавать', 'море'], category: 'Спорт'},
    {text: 'Бокс', forbidden: ['перчатки', 'ринг', 'удар', 'нокаут'], category: 'Спорт'},
    {text: 'Йога', forbidden: ['растяжка', 'коврик', 'медитация', 'поза'], category: 'Спорт'},
    {text: 'Велосипед', forbidden: ['колёса', 'педали', 'ездить', 'руль'], category: 'Спорт'},
    {text: 'Лыжи', forbidden: ['снег', 'гора', 'зима', 'палки'], category: 'Спорт'},
    {text: 'Шахматы', forbidden: ['доска', 'король', 'фигуры', 'мат'], category: 'Спорт'},

    // Путешествия
    {text: 'Аэропорт', forbidden: ['самолёт', 'билет', 'полёт', 'багаж'], category: 'Путешествия'},
    {text: 'Отель', forbidden: ['номер', 'гостиница', 'ночёвка', 'ресепшн'], category: 'Путешествия'},
    {text: 'Чемодан', forbidden: ['вещи', 'сумка', 'аэропорт', 'колёсики'], category: 'Путешествия'},
    {text: 'Пляж', forbidden: ['песок', 'море', 'солнце', 'загорать'], category: 'Путешествия'},
    {text: 'Виза', forbidden: ['паспорт', 'граница', 'посольство', 'документ'], category: 'Путешествия'},
    {text: 'Палатка', forbidden: ['лагерь', 'поход', 'спальник', 'костёр'], category: 'Путешествия'},

    // Праздники и события
    {text: 'Новый год', forbidden: ['ёлка', 'Дед Мороз', 'праздник', 'подарки'], category: 'Праздники'},
    {text: 'День рождения', forbidden: ['торт', 'подарок', 'свечи', 'праздник'], category: 'Праздники'},
    {text: 'Свадьба', forbidden: ['жених', 'невеста', 'кольца', 'платье'], category: 'Праздники'},
    {text: 'Хэллоуин', forbidden: ['тыква', 'костюм', 'страшно', 'конфеты'], category: 'Праздники'},
    {text: 'Выпускной', forbidden: ['школа', 'вечер', 'диплом', 'платье'], category: 'Праздники'},

    // Быт и дом
    {text: 'Холодильник', forbidden: ['еда', 'кухня', 'холодный', 'морозилка'], category: 'Быт'},
    {text: 'Пылесос', forbidden: ['пыль', 'уборка', 'ковёр', 'шум'], category: 'Быт'},
    {text: 'Будильник', forbidden: ['утро', 'звонить', 'проснуться', 'время'], category: 'Быт'},
    {text: 'Зонт', forbidden: ['дождь', 'мокрый', 'зонтик', 'капли'], category: 'Быт'},
    {text: 'Диван', forbidden: ['сидеть', 'подушка', 'гостиная', 'мягкий'], category: 'Быт'},
    {text: 'Ключи', forbidden: ['дверь', 'замок', 'открыть', 'связка'], category: 'Быт'},
];
